import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        padding: 48,
        gap: 20,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    logo: {
        height: 24,
        width: 'auto',
        marginRight: 8,
    },
    logoText: {
        color: '#044E8E',
        fontSize: 12,
        fontWeight: 'bold',
    },
    text: {
        fontSize: 12,
    },
    table: {
        width: '100%',
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#044E8E',
        borderTopWidth: 1,
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderColor: '#044E8E',
        borderStyle: 'solid',
        color: '#FFF',
        fontSize: 8,
        fontWeight: 'semibold',
        textAlign: 'center',
    },
    tableHeaderCell: {
        paddingVertical: 4,
        paddingHorizontal: 8,
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderColor: '#044E8E',
    },
    tableRow: {
        flexDirection: 'row',
        backgroundColor: '#FFF',
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderColor: '#E3E3E4',
        borderStyle: 'solid',
        color: '#000',
        fontSize: 8,
    },
    tableCell: {
        paddingVertical: 4,
        paddingHorizontal: 8,
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderColor: '#E3E3E4',
    },
});

const PdfTemplate = ({ columns, rows, logoUrl, title }) => {
    // Get current date and time
    const now = new Date();
    
    // Format date: DD/MM/YYYY
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    
    // Format time: HH:mm:ss
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    // Final formatted string
    const currentDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} WIB`;
    
    return (
        <Document>
            <Page size='A4' style={styles.page}>
                {/* Header */}
                <View style={styles.header}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Image src={logoUrl} style={styles.logo} />
                        <Text style={styles.logoText}>{title}</Text>
                    </View>
                    <Text style={styles.text}>{currentDate}</Text>
                </View>
                
                {/* Table */}
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={styles.tableHeader}>
                        {columns.map((column) => (
                            <View key={column.field} style={{ ...styles.tableHeaderCell, flex: 1 }}>
                                <Text style={{ color: '#FFF' }}>{column.title}</Text>
                            </View>
                        ))}
                    </View>
                    
                    {/* Table Rows */}
                    {rows.map((row, rowIndex) => (
                        <View key={rowIndex} style={styles.tableRow}>
                            {columns.map((column) => (
                                <View key={column.field} style={{ ...styles.tableCell, flex: 1 }}>
                                    <Text>{row[column.field] || '-'}</Text>
                                </View>
                            ))}
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );
};

export default PdfTemplate;
